<template>
    <div class="card card-travel-preview bg-light text-dark" :data-travel-date="travelDate.get('no')" v-if="travelDate.get('id')">
        <div class="price" v-if="state.price">ab&nbsp;
            <price :given="state.price" />
        </div>
        <div v-if="travelDate.get('travel.isShorty')" class="shorty">Shorty</div>
        <a :href="$route('travel-destination', travelDate.travel.data)">
            <!-- <img :src="travelDate.travel.data.travelInfo.teaserMediumUrls[0]" class="card-img-top" alt="Urlaubsziel" /> -->
            <img v-if="travelDate && travelDate.travel && travelDate.travel.data && travelDate.travel.data.travelInfo && travelDate.travel.data.travelInfo.teaserMediumUrls && travelDate.travel.data.travelInfo.teaserMediumUrls.length > 0"
                :src="travelDate.travel.data.travelInfo.teaserMediumUrls[0]"
                class="card-img-top"
                alt="Urlaubsziel" />
        </a>
        <div class="card-body">
            <h5 class="text-dark mb-2" v-if="travelDate.get('travel.destination')">
                <i class="fas fa-mountain h3"></i>
                {{ travelDate.get("travel.destination") }}
            </h5>
            <p v-if="travelDate.get('travel.country')" class="lh-1 mb-2">
                <small>{{ travelDate.get("travel.country") }}</small>, <small>{{ travelDate.get("timespan") }}<br>(Selbstfahrer ab dem {{ travelDateFrom.seperate }})</small>
            </p>
            <div class="card-text mt-3" v-html="description.limited"></div>
            <div class="badge bg-primary"></div>
        </div>
        <div class="card-footer d-flex justify-content-between">
            <a :href="$route('travel-destination', travelDate.travel.data)" class="btn btn-primary rounded-pill mb-4">
                <i class="fa-solid fa-person-skiing"></i> Zur Reise
            </a>
            <Link v-if="!travelDate.data.bookedOut" :href="$route('booking.step2', travelDate.get('slug'))" class="btn btn-primary rounded-pill mb-4"><i class="fa-solid fa-calendar-days"></i> Buchen</Link>
            <Link v-if="travelDate.data.bookedOut" :href="generateLink(travelDate)" class="btn btn-primary rounded-pill mb-4 btn-secondary">Auf Anfrage</Link>
        </div>
    </div>
</template>
<script setup>
import { computed, inject, onMounted, reactive } from "vue";
import { Link } from "@inertiajs/inertia-vue3";
import TravelDate from "../../Models/TravelDate";
import Search from "../../Models/Search";
import Price from "./Price";

const route = inject("route");

const props = defineProps({ model: Object });

const travelDate = computed(() => TravelDate.make(props.model));
const search = computed(() => new Search().fromStorage());

const state = reactive({
    price: 0,
    contingents: null,
});

const description = reactive({
    limited: null,
});

const travelDateFrom = reactive({
    seperate: null,
});

const priceFrom = async () => {
    axios
        .post(
            route("ratio.travel-date-price", {
                travelDate: travelDate.value.get("slug"),
            }),
            search.value.data
        )
        .then(function (response) {
            state.price = response.data.price;
        })
        .catch(function (error) {
            console.log(error);
        });
};

const contingents = async () => {
    axios
        .post(
            route("ratio.travel-date-contingents", {
                travelDate: travelDate.value.get("slug"),
            }),
            search.value.data
        )
        .then(function (response) {
            console.log(response.data.contingents);
            state.contingents = response.data.contingents;
        })
        .catch(function (error) {
            console.log(error);
        });
};

onMounted(async () => {
    await priceFrom();
    description.limited = travelDate.value.travel.travelInfo.description_limited

    let tomorrow = new Date(travelDate.value.from.getTime());
    tomorrow.setDate(travelDate.value.from.getDate() + 1);
    travelDateFrom.seperate = formatDate(tomorrow);
    console.log(travelDateFrom.seperate);

});
// onMounted(async () => {
//     await contingents()
// });


function formatDate(date) {
    // Format the date as "d.m.Y"
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
}

function generateLink(travelDate) {
    const subtitle = travelDate.get('subtitle') || travelDate.get('travel.destination') || '';
    const param = encodeURIComponent(subtitle);
    return `${route('inquiry')}/?reiseziel=${param}`;
}

</script>
